import { render, staticRenderFns } from "./InvestmentPreview.vue?vue&type=template&id=7402753c&scoped=true"
import script from "./InvestmentPreview.vue?vue&type=script&lang=js"
export * from "./InvestmentPreview.vue?vue&type=script&lang=js"
import style0 from "./InvestmentPreview.vue?vue&type=style&index=0&id=7402753c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7402753c",
  null
  
)

export default component.exports